import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Storages from './Storages';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    data,
    box,
    selectedBox,
    isLoadingDetails,
    deletedStorage,
    error,
    message,
    notifiedUser,
    storageMoved,
  } = state.box;
  return {
    isLoading,
    data,
    box,
    selected: selectedBox,
    isLoadingDetails,
    deletedStorage,
    error,
    message,
    notifiedUser,
    storageMoved,
  };
}

const Styled = withStyles(styles)(Storages);

export default connect(
  mapStateToProps,
)(Styled);
